import { render, staticRenderFns, recyclableRender, components } from "./l-ball.vue?vue&type=template&id=72d90493&"
var renderjs
import script from "./l-ball.vue?vue&type=script&lang=ts&"
export * from "./l-ball.vue?vue&type=script&lang=ts&"
import style0 from "./l-ball.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/lime-ball/components/l-ball/l-ball.vue"
export default component.exports